import * as Types from '../../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateCourseMutationVariables = Types.Exact<{
  input: Types.CreateCourseInput;
}>;


export type CreateCourseMutation = { __typename?: 'MutationRoot', createCourse: { __typename?: 'Course', id: string, name: string } };


export const CreateCourseDocument = gql`
    mutation CreateCourse($input: CreateCourseInput!) {
  createCourse(input: $input) {
    id
    name
  }
}
    `;

export function useCreateCourseMutation() {
  return Urql.useMutation<CreateCourseMutation, CreateCourseMutationVariables>(CreateCourseDocument);
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateCourseMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ createCourse })
 *   )
 * })
 */
export const mockCreateCourseMutation = (resolver: ResponseResolver<GraphQLRequest<CreateCourseMutationVariables>, GraphQLContext<CreateCourseMutation>, any>) =>
  graphql.mutation<CreateCourseMutation, CreateCourseMutationVariables>(
    'CreateCourse',
    resolver
  )
